import React, { useContext, useState } from "react";
import { modalBoxStyle } from "./styles";
import {
  Button,
  Typography,
  Box,
  Modal,
  CircularProgress,
} from "@mui/material";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import Store from "../../Store/Store";
import { useMutation, useQueryClient } from "react-query";
import inventoryClient from "../../clients/inventoryClient";

const DeleteMenuModal = ({
  deleteCallback,
  menuId,
  isOpen,
  toggleModalOpen,
  errorCallback,
}) => {
  const [loading, toggleLoading] = useState(false);
  const store = useContext(Store);
  const queryClient = useQueryClient();

  const closeModal = () => {
    toggleModalOpen(false);
  };

  const deleteMenuMutation = useMutation(
    inventoryClient.deleteMenu,
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [
            "menus-paginated"
          ],
        });
        queryClient.refetchQueries({
          queryKey: [
            "menus-paginated"
          ],
        });
        queryClient.invalidateQueries({
          queryKey: [
            "paginated-menu-search"
          ],
        });
        queryClient.refetchQueries({
          queryKey: [
            "paginated-menu-search"
          ],
        });
        deleteCallback();
        closeModal();
      },
    }
  );

  const handleDeleteCallback = async () => {
    try {
      toggleLoading(true);
      const archivePayload = {
        establishmentId: store.currentEstablishment?.id,
        menuId: menuId,
      };
  
      deleteMenuMutation.mutate(archivePayload);
      toggleLoading(false);
    } catch (err) {
      console.log(err);
      toggleLoading(false);
      errorCallback("There was an error trying to delete your item.");
    }
  };

  return (
    <Modal
      open={isOpen}
      onClose={closeModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={modalBoxStyle}>
        {loading ? (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <CircularProgress />
          </div>
        ) : (
          <>
            <Box>
              <Box
                sx={{
                  marginBottom: "1rem",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <DeleteOutlineOutlinedIcon sx={{ fontSize: "60px" }} />
              </Box>
              <Box
                sx={{
                  marginBottom: "1rem",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Typography variant="h2">Delete Menu</Typography>
              </Box>
              <Box
                sx={{
                  marginBottom: "1rem",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Typography variant="body1" sx={{ textAlign: "center" }}>
                  {"Are you sure you want to delete this menu? "}
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ textAlign: "center", marginTop: 1 }}
                >
                  {
                    "By selecting yes, you will lose all information associated with this menu."
                  }
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Button
                  sx={{ borderRadius: 2 }}
                  variant="outlined"
                  onClick={() => {
                    toggleModalOpen();
                  }}
                >
                  <Typography variant="smallButton">No, Cancel</Typography>
                </Button>
                <Button
                  variant="contained"
                  type="submit"
                  sx={{ borderRadius: 2, marginLeft: 2 }}
                  onClick={handleDeleteCallback}
                >
                  <Typography variant="smallButton">Yes, Delete</Typography>
                </Button>
              </Box>
            </Box>
          </>
        )}
      </Box>
    </Modal>
  );
};

export default DeleteMenuModal;
